import { optionsToVariantName } from "@helpers/products/optionsToVariantName";

import { Item } from "@typings/product/item";
import { Offer } from "@typings/product/offer";

export const getProductPrice = (
  item: Item,
  offer: Offer,
  selectedOptions: { [optionId: number]: number },
  isPromotion = false
) => {
  if (item.category.name === "Free Gift") return { price: 0, oldPrice: 0 };

  let { price } = item.variants.find(
    (v) => v.offerId === offer.id && v.name === optionsToVariantName(item.options, selectedOptions)
  )!;
  let oldPrice = price;

  if (isPromotion) {
    price = +(price * 0.75).toFixed(2);
  }

  // To show difference in price between subscription and one time offers
  // Not eligible for promotions
  if (!isPromotion && offer.name === "Monthly Subscription") {
    oldPrice = item.variants.find(
      (v) =>
        v.offerId !== offer.id && v.name === optionsToVariantName(item.options, selectedOptions)
    )!.price;
  }

  return { price, oldPrice };
};
